/*
 * Mensaje en español para un error de axios del tablero de Marcaciones. Usa el `mensaje` que manda el
 * backend (401 sin permiso, 406 filtros no válidos, etc.) y, si no hay, uno propio que dice qué pasó
 * y qué hacer. Lo usan hooks/useRemoteData.js y la exportación a Excel (etapa 5).
 */
export function errorMessage(error) {
    const response = error && error.response;
    if (response && response.data && typeof response.data.mensaje === 'string') return response.data.mensaje;
    if (response && response.status === 401) return 'Tu usuario no tiene permiso para ver las marcaciones.';
    if (response) return `El servidor respondió con un error (${response.status}). Inténtalo de nuevo en unos minutos.`;
    return 'No hay conexión con el servidor. Revisa tu conexión e inténtalo de nuevo.';
}
